// 📦 File: frontend/src/pages/Settings/Comp/ResetPassword.jsx (integrated)
import React, { useState } from "react";
import Classes from "../Settings.module.css";
import { useSelector } from "react-redux";
import backend from "../../../../../../api";

export default function ResetPassword() {
  const { user } = useSelector((s) => s.auth);
  const [form, setForm] = useState({ password: "", confirmPassword: "" });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.password || !form.confirmPassword) {
      return setMessage("Both fields are required.");
    }
    if (form.password !== form.confirmPassword) {
      return setMessage("Passwords do not match.");
    }

    setLoading(true);
    try {
      await backend.put(`/api/user/changepassword/${user._id}`, {
        password: form.password,
      });
      setMessage("Password updated successfully.");
      setForm({ password: "", confirmPassword: "" });
    } catch (err) {
      console.error("Password reset failed", err);
      setMessage("Failed to update password. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className={Classes.form} onSubmit={handleSubmit}>
      <div className={Classes.flexColGroup}>
        <div className={Classes.flexCol1}>
          <h5 className={Classes.label}>Password</h5>
          <input
            type="password"
            className={Classes.inputField}
            name="password"
            value={form.password}
            onChange={onChange}
            placeholder="Password"
            required
          />
        </div>
        <div className={Classes.flexCol1}>
          <h5 className={Classes.label}>Confirm Password</h5>
          <input
            type="password"
            className={Classes.inputField}
            name="confirmPassword"
            value={form.confirmPassword}
            onChange={onChange}
            placeholder="Confirm Password"
            required
          />
        </div>
      </div>

      {message && <div className={Classes.formMessage}>{message}</div>}

      <div className={Classes.actions}>
        <button type="submit" className={Classes.saveBtn} disabled={loading}>
          <h5>{loading ? "Updating..." : "Reset Password"}</h5>
        </button>
      </div>
    </form>
  );
}
